// extracted by mini-css-extract-plugin
module.exports = {"textWrapper":"offer-layout-module--text-wrapper--2nYg7","reverse":"offer-layout-module--reverse--fdd1Y"};